import React from "react";
import FooterAnimation from "./FooterAnimation";
import FooterMenu from "./FooterMenu";

const Footer = () => {
  return (
    <>
      <FooterMenu />
      <FooterAnimation />
    </>
  );
};

export default Footer;
